import { JetView } from 'webix-jet'; // Importing JetView from webix-jet
import { allpayments } from 'models/allpayments'; // Importing allpayments model
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * Class representing the view for auto-exclusion users table.
 */
export default class tableAutoexclusionUsersView extends JetView {
    /**
     * Configures the datatable for displaying auto-exclusion users.
     * @returns {Object} Configuration object for the datatable.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat); // Date formatting function
        const cur_user = this.getParam('user', true); // Current user ID from parameters

        return {
            view: 'datatable', // Datatable view
            css: 'webix_header_border webix_data_border webix_footer_border', // CSS classes for styling
            select: true, // Enable row selection
            columns: [
                // Column definitions for the datatable
                {
                    id: 'detailTittle',
                    header: '',
                    width: 50,
                    height: 25,
                    tooltip: 'Detalles', // Tooltip for details column
                    template: function (obj) {
                        // Template for detail icon
                        return "<span class='webix_icon wxi-close details'></span>";
                    },
                },
                { id: 'Id', header: 'Id', width: 100, sort: 'int' }, // ID column
                {
                    id: 'PlayerId',
                    header: 'ID Usuario', // User ID column
                    width: 100,
                    sort: 'int',
                },
                {
                    id: 'UserName',
                    header: 'Usuario (Correo electrónico)', // User email column
                    width: 250,
                    sort: 'int',
                },
                {
                    id: 'State',
                    header: 'Estado', // State column with options
                    options: [
                        { id: '', value: 'None' },
                        { id: 'A', value: 'Activado' },
                        { id: 'C', value: 'Canceled' },
                        { id: 'I', value: 'Inactivado' },
                    ],
                    width: 100,
                    sort: 'int',
                },
                {
                    id: 'Category',
                    header: 'Categorías', // Category column
                    width: 100,
                    sort: 'int',
                },
                {
                    id: 'SubCategory',
                    header: 'Sub Categoría', // Sub-category column
                    width: 100,
                    sort: 'int',
                },
                { id: 'Game', header: 'Juego', width: 100, sort: 'int' }, // Game column
                {
                    id: 'FinalDate',
                    header: _('Fecha final de la autoexclusión'), // Final exclusion date column
                    fillspace: 0,
                    minWidth: 0,
                    width: 250,
                    sort: 'text',
                    format: dateFormat, // Date format for the column
                },
                {
                    id: 'UserCreation',
                    header: 'Usuario Creación', // User creation column
                    width: 200,
                    sort: 'int',
                },
                {
                    id: 'UserModified',
                    header: 'Usuario Modificó', // User modified column
                    width: 200,
                    sort: 'int',
                },
            ],
            onClick: {
                // Event handler for clicking the details icon
                details: function (euv, id) {
                    this.app.callEvent('user:id', id); // Trigger user ID event
                },
            },
            tooltip: true, // Enable tooltips
            math: true, // Enable math operations
            loadahead: devConfig.getDefaultDataFetch(), // Load ahead configuration
            loadahead: 5, // Number of rows to load ahead
            pager: 'pagerA', // Pager ID
            // API URL for fetching data
            url: devConfig.geturlApi() + 'null/Report/getRegisteredAutoexclusion?PlayerId=' + cur_user + '&',
        };
    }

    /**
     * Initializes the datatable and sets up event listeners.
     * @param {Object} grid - The datatable instance.
     */
    init(grid) {
        const cur_user = this.getParam('user', true); // Current user ID
        var url = grid.data.url; // URL for data loading

        this.on(this.app, 'autoexclusionUsers:filter', (filterData) => {
            // Event for filtering data
            var object = Object.entries(filterData); // Convert filter data to entries
            var string1 = ''; // Query string for filters

            for (var i = 0; i < object.length; i++) {
                // Iterate through filter entries
                if (typeof object[i][1] !== 'object' && object[i][1] !== '') {
                    if (object[i][0] == 'Datepicker') {
                        // Handle date range filter
                        var date = object[i][1].split(' - ');
                        console.log(date);
                        string1 = string1 + '&dateFrom=' + date[0];
                        string1 = string1 + '&dateTo=' + date[1];
                    } else {
                        string1 = string1 + '&' + object[i][0] + '=' + object[i][1]; // Append other filters
                    }
                } else {
                    if (typeof object[i][1] === 'object') {
                        // Handle object filters
                        var object2 = Object.entries(object[i][1]);
                        for (var j = 0; j < object2.length; j++) {
                            if (object2[j][1] !== null) {
                                if (object2[j][0] === 'start') {
                                    // Start date filter
                                    var d = new Date(object2[j][1]);
                                    var dateFrom =
                                        'MaxCreatedLocal=' +
                                        d.getFullYear() +
                                        ':' +
                                        ('00' + (d.getMonth() + 1)).slice(-2) +
                                        ':' +
                                        ('00' + d.getDate()).slice(-2) +
                                        ' ' +
                                        ('00' + d.getHours()).slice(-2) +
                                        ':' +
                                        ('00' + d.getMinutes()).slice(-2) +
                                        ':' +
                                        ('00' + d.getSeconds()).slice(-2);
                                    string1 = string1 + '&' + dateFrom; // Append start date to query
                                } else {
                                    if (object2[j][0] === 'end') {
                                        // End date filter
                                        var d = new Date(object2[j][1]);
                                        var dateTo =
                                            'MinCreatedLocal=' +
                                            d.getFullYear() +
                                            ':' +
                                            ('00' + (d.getMonth() + 1)).slice(-2) +
                                            ':' +
                                            ('00' + d.getDate()).slice(-2) +
                                            ' ' +
                                            ('00' + d.getHours()).slice(-2) +
                                            ':' +
                                            ('00' + d.getMinutes()).slice(-2) +
                                            ':' +
                                            ('00' + d.getSeconds()).slice(-2);
                                        string1 = string1 + '&' + dateTo; // Append end date to query
                                    }
                                }
                            }
                        }
                    }
                }
            }
            string1 = string1 + '&PlayerId=' + cur_user; // Append current user ID to query
            grid.clearAll(); // Clear existing data in the grid
            grid.load(url + '?start=0&count=' + grid.data.$pagesize + string1); // Load new data with filters
        });

        grid.attachEvent('onAfterSelect', (obj) => {
            // Event after row selection
            this.app.callEvent('user:id', [obj.Id]); // Trigger user ID event
        });

        grid.attachEvent('onBeforeDataSend', function (send) {
            // Event before data is sent
            webix.message('Loading2...'); // Show loading message
        });

        grid.attachEvent('onDataRequest', function (start, count) {
            // Event for data request
            custom_load(this.data.url, start, count); // Custom load function call
            return true;
        });

        /**
         * Custom function to load data with pagination.
         * @param {string} url - The URL for data loading.
         * @param {number} start - The starting index for data.
         * @param {number} count - The number of records to load.
         */
        function custom_load(url, start, count) {
            grid.load(
                url + '?start=' + start + '&count=' + count + '&PlayerId' + cur_user, // Load data with pagination and current user ID
            );
        }

        grid.attachEvent('onBeforeLoad', function () {
            // Event before loading data
            webix.message('Loading...'); // Show loading message
            return true;
        });

        this.on(this.app, 'player:select', (id) => {
            // Event for player selection
            grid.load(
                grid.data.url + '?start=0&count=' + grid.data.$pagesize + '&PlayerId=' + id, // Load data for selected player
            );
        });
    }
}

// FILE DOCUMENTED
